import { Fragment } from 'react';
import { Row } from 'reactstrap';
import RightHeader from '@layout/header/rightbar';

const Header = (props) => {
  return (
    <Fragment>
      <div className="page-header">
        <Row className="header-wrapper m-0">
          {/* <LeftHeader data={props.data} mid={props.mid} /> */}
          <RightHeader
            screenType={props.screenType}
            data={props.data}
            mid={props.mid}
            isShowSide={props.isShowSide}
            setIsShowSide={props.setIsShowSide}
          />
        </Row>
      </div>
    </Fragment>
  );
};

export default Header;
